var $ = require("jquery");

var Price = Backbone.Model.extend({ idAttribute: "price_id" });
var PriceCollection = Backbone.Collection.extend({ model: Price });

var CategoryInformationView = Backbone.View.extend({
  events: {
    "click [data-price]": "togglePrice",
    "collapserView:loading [data-results-view]": "catchSelectedCategory",
    "collapserView:loaded [data-results-view]": "toggleSelectedCategory",
    "airView:ready [data-flight-selection]": "togglePricedCategory",
    "click [data-clear-category]": "clearCheckedRadio",
    "click [data-category-selector]": "trackSelectedCategory",
    "click [data-rate-selected]": "autoSelectedCategory",
    "change [data-category-selector]": "trackSelectedCategory",
    "click [data-category-continue]": "triggerSelectedCategory",
    "click [data-category-terms-trigger]": "displayCategoryTerms",
    "click [data-rate-code-details-trigger]": "displayRateCodeDetails",
    "click [data-promo-details-trigger]": "displayPromoDetails",
    "click [data-flight-selector]": "processFlightSelection",
    "click [data-load-more]": "triggerLoadMore",
    "click [data-details-trigger]": "displaySelectedFlight",
    "click [data-cabin-type-filter]": "filterCabinTypes",
    "click [data-category-linked]": "checkCategorySelected",
    "click [data-category-deselect]": "uncheckCategorySelection"
  },

  filterCabinTypes: function(event) {
    var currentValue = $(event.currentTarget).val();
    this.$("[data-cabin-type-block]").addClass("is-hidden");

    if (currentValue === "all") {
      this.$("[data-cabin-type-block]").removeClass("is-hidden");
    } else {
      this.$("[data-cabin-type-block=" + currentValue + "]").removeClass(
        "is-hidden"
      );
    }
  },

  /**
   * This method triggers the click event of the selected category.
   */
  triggerSelectedCategory: function() {
    this.$("[data-category]:checked").trigger("click");
  },

  trackSelectedCategory: function(isInit) {
    let currentCabin = $(isInit.currentTarget).attr("data-current-cabin");
    let promotionsAvailable =
      this.$("[data-category-rate-promo]:checked").length > 0;
    let promotionsTermsAvailable =
      this.$("[data-category-terms-trigger]:checked").length > 0;
    let airAvailable = this.$('[data-tabs-label="flights"]').length > 0;

    let collapserTriggered =
      $(isInit.currentTarget).attr("data-collapser-trigger") ||
      $(isInit.currentTarget).attr("data-collapser-trigger-check");
    //Checking if quick quote button exists
    let quickQuote = $("[data-quick-quote-trigger]").length > 0;

    //check if promotion collapser is available
    if (isInit.type === "click") {
      this.collapserAvailable = $(isInit.currentTarget).attr(
        "data-collapser-trigger-check"
      );
    }

    this.selectedCategory = this.$("[data-category-selector]:checked").attr(
      "data-category-selector"
    );

    this.selectedView = this.$("[data-results-toggle]:checked").data(
      "resultsToggle"
    );

    let selectedCategoryButton = this.$(
      '[data-results-view="' +
        this.selectedView +
        '"] [data-category-selector="' +
        this.selectedCategory +
        '"]'
    );

    if (this.selectedView !== "standard" && isInit.type === "click") {
      this.openSelectedCategoryPromotion(
        selectedCategoryButton,
        this.selectedView
      );
    }

    //If promotion collapser available, then remove class
    if (collapserTriggered) {
      $("[data-collapser-id='" + collapserTriggered + "']").removeClass(
        "category-not-selected"
      );
    }

    // If there is no promotion collapser available
    if (this.selectedCategory && isInit && !this.collapserAvailable) {
      // move to the flights tab if there are flights and none was selected
      if (
        this.$('[data-tabs-label="flights"]').length &&
        !this.$("[data-flight-selector]:checked").length
      ) {
        this.animateTabSwitch('[data-tabs-label="flights"]');
      }
    }

    //If no promotions available or quick quote CTA, submit
    if (
      (isInit.type === "click" || isInit.type === "change") &&
      !promotionsAvailable &&
      !promotionsTermsAvailable &&
      !airAvailable &&
      !this.toggleViewCategory
    ) {
      if (
        !quickQuote &&
        parseInt(currentCabin) === parseInt(this.settings.cabins) &&
        !this.settings.isRiver
      ) {
        this.$el.closest("form").submit();
      } else {
        this.animateTabSwitch("[data-scroll-bottom]");
      }
    }

    this.toggleViewCategory = false;
  },

  // handle continue button when the promotion icon is pressed
  autoSelectedCategory: function(e) {
    e.preventDefault();

    let currentCta = $(e.currentTarget);
    let currentCategory = currentCta.data("rateSelected");
    let currentCategoryCta = $("#" + currentCategory);

    this.promotionViewTrigger = true;

    if (!currentCategoryCta.is(":checked")) {
      if (this.$el.is("[data-form-section-valid]")) {
        this.$("[data-form-section-valid]").attr(
          "[data-form-section-valid]",
          true
        );
      }

      currentCategoryCta.trigger("click");

      if (
        !currentCategoryCta.is("[data-category-terms-trigger]") &&
        !currentCta.is('[data-tabs-label="flights"]')
      ) {
        this.$el.parents("[data-category-form]").submit();
      }
    } else if (
      currentCategoryCta.is(":checked") &&
      !currentCta.is('[data-tabs-label="flights"]')
    ) {
      this.$el.parents("[data-category-form]").submit();
    }

    return true;
  },

  //Check if triggered promotions belongs to a selected category
  checkCategorySelected: function(event) {
    var $data = $(event.currentTarget).data(),
      $collapserRelated = $(
        "[data-collapser-id='" + $data.collapserTrigger + "']"
      );
    this.selectedView = this.$("[data-results-toggle]:checked").data(
      "resultsToggle"
    );

    //If category button is not selected, add class to hide Continue button
    $("[data-category-id='" + $data.categoryLinked + "']:checked").length
      ? $collapserRelated.removeClass("category-not-selected")
      : $collapserRelated.addClass("category-not-selected");

    this.setWidth(this.selectedView, $collapserRelated);
  },

  togglePrice: function(event) {
    this.$el.removeClass("is-full is-per-day");

    switch ($(event.currentTarget).data("price")) {
      case "per-day":
        this.$el.addClass("is-per-day");
        break;

      case "full":
        this.$el.addClass("is-full");
        break;
    }
  },

  /**
   * This method captures the selected Category
   */

  catchSelectedCategory: function() {
    this.selectedCategory = this.$("[data-category-selector]:checked").attr(
      "data-category-selector"
    );
  },

  /**
   * This method toggles the selected category when switching between results views
   */
  toggleSelectedCategory: function() {
    this.selectedView = this.$("[data-results-toggle]:checked").data(
      "resultsToggle"
    );

    if (this.selectedView === "group_matrix") {
      var cabinType = this.$(
        '[data-results-view="' +
          this.selectedView +
          '"] [data-category-selector="' +
          this.selectedCategory +
          '"]'
      ).data("categoryCabinType");

      if (cabinType) {
        var groupMatrix = this.$(
          '[data-group-matrix-collapser="' + cabinType + '"]'
        );
        groupMatrix.find('[data-component="table-scroller"]').component();
        setTimeout(
          function() {
            groupMatrix.component().open();
          }.bind(this),
          0
        );
      }
    }

    // while toggling the view if a category is already selected open its promotion collapser and set its width
    if (this.selectedCategory) {
      var selectedCategoryButton = this.$(
        '[data-results-view="' +
          this.selectedView +
          '"] [data-category-selector="' +
          this.selectedCategory +
          '"]'
      );
      this.$("[data-category-selector]").removeAttr("checked");

      this.toggleViewCategory = true;
      selectedCategoryButton.prop("checked", true).trigger("change");

      this.openSelectedCategoryPromotion(
        selectedCategoryButton,
        this.selectedView
      );
    }

    // // Packaged pricing logic will only occur if the settings contains the load pricing  url
    if (this.flightsModule.is("[data-air-results]") && this.flightsModel) {
      this.togglePricedCategory();
    }
  },

  togglePricedCategory: function(e) {
    this.flightsOperations(e);
  },

  openSelectedCategoryPromotion: function(
    selectedCategoryButton,
    selectedView
  ) {
    let collapserId = selectedCategoryButton.attr(
      "data-collapser-trigger-check"
    );
    let cabinTrigger = selectedCategoryButton.is("[data-cabin-trigger]");

    if (cabinTrigger) {
      let cabinCollapser = $('[data-collapser-id="' + collapserId + '"]');

      cabinCollapser.component().open();
    } else if (collapserId) {
      // if selected category has promotion then open the promotion collapser

      let promotion = this.$('[data-collapser-id="' + collapserId + '"]');

      if (promotion.length) {
        promotion.component().open();
        //set the width of static item
        this.setWidth(selectedView, promotion);
      }
    }
  },

  // Set the width of table-scroller-static-item (promotion collapser) according to matrix table container width
  setWidth: function(selectedView, promotion) {
    if (this.selectedView !== "standard") {
      //wait for the collapser to laod
      setTimeout(
        function() {
          if (this.selectedView === "group_matrix") {
            var promotionContainer = promotion.find(
                "[data-table-scroller-static-item]"
              ),
              panel = promotion.parents(".panel.is-expandable"),
              padding =
                parseFloat(promotionContainer.parent().css("padding-right")) +
                parseFloat(promotionContainer.parent().css("padding-left"));

            var itemWidth =
              panel.width() - padding - panel[0].offsetLeft * 2 + "px";
          } else {
            var mask = promotion.parents("[data-table-scroller-mask]");
            var itemWidth = mask.css("width");
          }
          promotion
            .find("[data-table-scroller-static-item]")
            .css("width", itemWidth);
          promotion
            .find("[table-scroller-static-item]")
            .css("width", itemWidth);
        }.bind(this),
        400
      );
    }
  },

  /**
   * This method unchecks the radio that was previously selected.
   *
   * @param event
   */
  clearCheckedRadio: function(event) {
    $(event.currentTarget)
      .removeAttr("checked")
      .trigger("change");
  },

  processPromotionSelection: function(event) {
    let currentCabin = $(event.currentTarget).attr("data-cabin-section-label");
    var promotionSelection = this.$("[data-category-promotion-selection]").html(
        this.templates.promoSelection({
          component_id: $(event.currentTarget).attr(
            "data-category-promotion-selector"
          )
        })
      ),
      flightsTab = this.$('[data-tabs-label="flights"]'),
      promotionsTab = this.$('[data-tabs-label="promotions"]');

    promotionSelection.loadComponents();
    promotionSelection.loadModules();

    // move to the flights tab if there are flights and none was selected
    if (flightsTab.length && !this.$("[data-flight-selector]:checked").length) {
      flightsTab.click();
      this.animateTabSwitch('[data-tabs-label="flights"]');
    } else if (!flightsTab.length && promotionsTab.length) {
      promotionsTab.click();
      this.animateTabSwitch('[data-tabs-label="promotions"]');
    } else if (parseInt(currentCabin) !== parseInt(this.settings.cabins)) {
      this.$el.closest("form");
      this.animateTabSwitch("[data-scroll-bottom]");
    } else {
      this.$el.closest("form").submit();
    }
  },

  checkSelectedFlight: function() {
    $(
      '[data-flight-selector="' + this.flightsModel.get("selectedFlight") + '"]'
    ).prop("checked", true);
  },

  processFlightSelection: function(event) {
    var selectedFlight = $(event.currentTarget);
    var selectedFlightValue = selectedFlight.val();

    // Save in flight session storage
    this.flightsModel.attributes.selectedFlight = selectedFlightValue;
    this.flightsModel.trigger("change:legNumber");

    this.$("[data-details-trigger]").removeClass("is-hidden");

    this.$("[data-flight-container]").removeClass("is-selected");
    this.$('[data-flight-container="' + selectedFlightValue + '"]').addClass(
      "is-selected"
    );

    if (!this.selectedCategory) {
      this.$('[data-tabs-label="categories"]').click();
      this.animateTabSwitch('[data-tabs-label="categories"]');
    } else {
      // move to the bottom if there are no promotions
      this.animateTabSwitch("[data-scroll-bottom]");
    }
  },

  animateTabSwitch: function(selector, offset) {
    let currentOffset = offset || 0;
    let panelSubmit = $("[data-panel-submit]").first();

    let bottomPosition =
      $(this.$(selector)).offset().top -
      currentOffset -
      $(window).height() +
      panelSubmit.outerHeight(true);

    if (this.$(selector)) {
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: bottomPosition
          },
          1000
        );
      this.$(selector)[0].click();
    }
  },

  displayCategoryTerms: function(event) {
    var content = this.templates.categoryTerms({
      componentId: $(event.currentTarget).data("category-terms-trigger"),
      promoCollapserPrepend: $(event.currentTarget).data(
        "promo-collapser-prepend"
      )
    });

    var Dialog = this.containers.categoryTerms.html(content).component();

    Dialog.reflow().open();

    // register listeners for the accept/decline buttons
    Dialog.currentModal
      .on("click", "[data-terms-declined]", function(event) {
        var componentId = $(event.currentTarget).attr("data-terms-declined"),
          categoryControl = $(
            '[data-category-selector="' + componentId + '"]:checked'
          );

        //Closing promotions collapser in case it exists
        categoryControl.data("collapser-trigger")
          ? $(
              "[data-collapser-id='" +
                categoryControl.data("collapser-trigger") +
                "'] [data-collapser-trigger]"
            )[0].click()
          : false;

        //Uncheck category which T&C were declined
        categoryControl.prop("checked", false).trigger("change");
      })
      .on(
        "click",
        "[data-terms-accepted]",
        function(event) {
          if (!$(event.currentTarget).is("[data-category-rate-promo]")) {
            this.processPromotionSelection(event);
          }

          if (this.promotionViewTrigger) {
            this.$el.parents("[data-category-form]").submit();
          }
        }.bind(this)
      );
  },

  displayRateCodeDetails: function(event) {
    var url = $(event.currentTarget).data("rate-code-details-trigger");

    var Dialog = this.containers.rateCodeDetails
      .data("dialog-async", url)
      .component();

    Dialog.reflow().open();
  },

  displayPromoDetails: function(event) {
    var content = this.templates.promoDetails({
      versionId: $(event.currentTarget).data("promo-details-trigger")
    });

    var Dialog = this.containers.promoDetails.html(content).component();

    Dialog.reflow().open();
  },

  displaySelectedFlight: function(e) {
    e.leg = this.$('[data-flight="' + this.selectedFlight + '"]').clone();

    // Use the built in function for opening the dialog on the selection module
    $('[data-module="selection"]')
      .component()
      .triggerDetailsModal(e);
  },

  initTemplates: function() {
    this.templates = {
      categoryDetails: Handlebars.compile(
        this.$('[data-template="category-details"]').html() || ""
      ),
      categoryTerms: Handlebars.compile(
        this.$('[data-template="category-terms"]').html() || ""
      ),
      promoDetails: Handlebars.compile(
        this.$('[data-template="promo-details"]').html() || ""
      ),
      promoSelection: Handlebars.compile(
        this.$('[data-template="promotion-selection"]').html() || ""
      ),
      price: Handlebars.compile(this.$('[data-template="price"]').html() || "")
    };
  },

  initContainers: function() {
    this.containers = {
      categoryDetails: null,
      categoryTerms: null,
      rateCodeDetails: null,
      promoDetails: null
    };

    this.containers.categoryDetails = this.$("[data-category-details-modal]");
    this.containers.categoryTerms = this.$("[data-category-terms-modal]");
    this.containers.rateCodeDetails = this.$("[data-rate-code-details-modal]");
    this.containers.promoDetails = this.$("[data-promo-details-modal]");
  },

  updateCategoryPrices: function(loadFailed) {
    var self = this;
    var containers = this.$("[data-category-price]");

    if (this.pricesLoaded || loadFailed) {
      _.each(containers, function(el) {
        var price = self.categoryPrices.get($(el).data("category-price"));

        $(el).html(
          self.templates.price({
            cruisePrice: true,
            loadFailed: loadFailed || false,
            status: $(el).data("category-status"),
            price: price ? price.toJSON() : {}
          })
        );
      });

      this.togglePrices("[data-category-price]", false);
      this.disableSelection("[data-category-selector]", false);
      this.disableSelection("[data-rate-selected]", false);
    }
  },

  updateFlightPrices: function(loadFailed) {
    var self = this;
    var containers = this.$("[data-flight-price]");

    if (this.pricesLoaded || loadFailed) {
      _.each(containers, function(el) {
        var price = self.flightPrices.get($(el).data("flight-price"));

        $(el).html(
          self.templates.price({
            loadFailed: loadFailed,
            price: price ? price.toJSON() : {}
          })
        );
      });

      this.togglePrices("[data-flight-price]", false);
      this.disableSelection("[data-flight-selector]", false);
    }
  },

  updateCabinTypePrices: function(loadFailed) {
    var self = this;
    var containers = this.$("[data-cabin-type-price]");

    if (this.pricesLoaded || loadFailed) {
      _.each(containers, function(el) {
        var price = self.cabinTypePrices.get($(el).data("cabin-type-price"));

        $(el).html(
          self.templates.price({
            cruisePrice: true,
            loadFailed: loadFailed || false,
            price: price ? price.toJSON() : {}
          })
        );
      });

      this.togglePrices("[data-cabin-type-price]", false);
    }
  },

  updateCategoryGroupPrices: function(loadFailed) {
    var self = this;
    var containers = this.$("[data-category-group-price]");

    if (this.pricesLoaded || loadFailed) {
      _.each(containers, function(el) {
        var price = self.categoryGroupPrices.get(
          $(el).data("category-group-price")
        );

        $(el).html(
          self.templates.price({
            cruisePrice: true,
            loadFailed: loadFailed || false,
            price: price ? price.toJSON() : {}
          })
        );
      });

      this.togglePrices("[data-category-group-price]", false);
    }
  },

  togglePrices: function(selector, isLoading) {
    if (!isLoading) {
      this.$(selector).removeClass("is-loading");
    } else {
      this.$(selector)
        .empty()
        .addClass("is-loading");
    }
  },

  disableSelection: function(selector, disable) {
    if (disable) {
      this.$(selector).attr("disabled", true);
    } else {
      this.$(selector).removeAttr("disabled");
    }
  },

  triggerLoadMore: function() {
    this.togglePrices("[data-category-price], [data-flight-price]", true);
  },

  loadPricing: function() {
    var self = this;

    // only request pricing if a pricing url is available
    if (!this.settings.urls.loadPricing) {
      return;
    }

    $.ajax({
      type: "GET",
      dataType: "json",
      cache: false,
      url: this.settings.urls.loadPricing,

      data: {
        flight_id: self.$("[data-flight-selector]:checked").val()
      },

      beforeSend: function() {
        self.togglePrices("[data-category-price], [data-flight-price]", true);
        self.disableSelection(
          "[data-category-selector], [data-flight-selector]",
          true
        );
      },

      success: function(response) {
        if (response.success === true) {
          self.currency = response.data.currency;
          self.categoryPrices = new PriceCollection(response.data.categories);
          self.flightPrices = new PriceCollection(response.data.flights);
          self.cabinTypePrices = new PriceCollection(response.data.cabin_types);
          self.categoryGroupPrices = new PriceCollection(
            response.data.category_groups
          );
          self.pricesLoaded = true;

          self.updateCategoryPrices(false);
          self.updateFlightPrices(false);
          self.updateCabinTypePrices(false);
          self.updateCategoryGroupPrices(false);

          self.selectedFlight = response.data.selected_flight;

          self.$("[data-details-trigger]").removeClass("is-hidden");

          self
            .$('[data-flight-selector="' + response.data.selected_flight + '"]')
            .attr("checked", true)
            .parents("[data-air-item]")
            .addClass("is-selected");
        } else {
          self.updateCategoryPrices(true);
          self.updateFlightPrices(true);
          self.updateCabinTypePrices(true);
          self.updateCategoryGroupPrices(true);
        }
      },

      error: function() {
        self.updateCategoryPrices(true);
        self.updateFlightPrices(true);
        self.updateCabinTypePrices(true);
        self.updateCategoryGroupPrices(true);
      }
    });
  },

  /**
   * Handles operations for flight related displays; Fires once when Redis is ready
   */
  flightsOperations: function(e) {
    // Loads model from selection.js module
    this.flightsModel =
      typeof this.flightsModel == "undefined"
        ? $(e.currentTarget).module().searchData
        : this.flightsModel;

    if (!this.settings.urls.loadPricing) {
      this.flightsModel.on(
        "change:viewsLoaded",
        this.checkSelectedFlight.bind(this)
      );
    } else {
      this.loadPricing();

      // Creates event listener for rendering prices
      this.flightsModel.on(
        "change:viewsLoaded",
        function() {
          if (this.pricesLoaded) {
            this.updateCategoryPrices();
            this.updateFlightPrices();
            this.updateCabinTypePrices();
            this.updateCategoryGroupPrices();
            this.checkSelectedFlight();
          }
        }.bind(this)
      );
    }
  },

  uncheckCategorySelection: function(e) {
    // removing valid flag for container

    if (this.$el.is("[data-form-section-valid]")) {
      this.$("[data-form-section-valid]").attr(
        "[data-form-section-valid]",
        false
      );
    }

    let unselectCategory = e.currentTarget.dataset.categoryDeselect;

    this.$el.find("#" + unselectCategory).prop("checked", false);
  },

  initialize: function() {
    this.settings = {
      urls: {}
    };

    if (this.$el.data("settings")) {
      this.settings = this.settings = $.extend(
        true,
        this.settings,
        this.$el.data("settings")
      );
    }

    this.selectedView = this.$("[data-results-toggle]:checked").data(
      "resultsToggle"
    );
    this.selectedCategory = null;
    this.selectedFlight = null;
    this.currency = null;
    this.categoryPrices = new PriceCollection();
    this.flightPrices = new PriceCollection();
    this.pricesLoaded = false;
    this.toggleViewCategory = false;

    this.promotionViewTrigger = false;

    this.flightsModule = this.$("[data-flight-selection]");

    let moveCategory = window.location.hash.substr(1) || false;

    if (moveCategory) {
      this.animateTabSwitch("#" + moveCategory, this.settings.offset);
    }

    this.initTemplates();
    this.initContainers();
    this.trackSelectedCategory(true);
    this.toggleSelectedCategory();

    if (this.settings.location) {
      var Grid = this.$("[data-category-grid]").component();

      Grid.resetFilters();

      this.$(
        '[data-filter-cabin-type="' + this.settings.location + '"]'
      ).click();
    }

    if (this.settings.component) {
      this.selectedCategory = this.settings.component;
      this.toggleSelectedCategory();
    }
  }
});

module.exports = CategoryInformationView;
